import {useMemo} from "react";
import {invoiceGroupBysSelector, useGetAllInvoiceGroupByTypesQuery} from "@ots-frontend/ots-data";
import {BaseSelect, BaseSelectProps} from "../../base-select";

type Props = Omit<BaseSelectProps, "data">

export const InvoiceGroupByTypeSelect = (props: Props) => {
  const {...rest} = props;

  const selectInvoiceGroupBys = useMemo(() => {
    return invoiceGroupBysSelector();
  }, []);

  const {data, isLoading} = useGetAllInvoiceGroupByTypesQuery(undefined, {
    selectFromResult: (result) => ({
      data: selectInvoiceGroupBys(result),
      isLoading: result.isLoading
    })
  });

  const sortedData = useMemo(() => {
    return [...data].sort();
  }, [data]);

  return (
    <BaseSelect
      data={sortedData}
      loading={isLoading}
      {...rest} />
  );
};
